<plyca-ui-input-text
  formControlName="title"
  [config]="{
    label: 'Input text Example',
    id: 'title',
    type: 'text',
    maxlength: 50,
    placeholder: '',
    isDisabled: false
  }"
/>
<br />
<plyca-ui-input-text
  formControlName="title"
  [config]="{
    label: 'Input password Example',
    id: 'title',
    type: 'password',
    maxlength: 50,
    placeholder: '',
    isDisabled: false
  }"
/>
